export const DISCORD_INVITE_URL = "https://discord.gg/V7hgKf6NWf";
export const TWITTER_URL = "https://twitter.com/CedeLabs";
export const LINKEDIN_URL = "https://www.linkedin.com/company/cede-labs";
export const TELEGRAM_URL = "https://t.me/+vCVyR7QbFIllMTY8";

export const CEDE_STORE_URL = "https://cede.store/";
export const CEDE_STORE_WIDGET_DOCUMENTATION_URL = "https://docs.cede.store/widgets/installation";
